import { COMMON_FILTER_FIELD_IDS } from '../../reports-components/shared-filter-fields';

export const COMMITMENT_VS_USAGE_FILTER_FIELD_IDS = Object.freeze({
  CustomerId: COMMON_FILTER_FIELD_IDS.Customer,
  Plan: COMMON_FILTER_FIELD_IDS.Plan,
  ContractStatus: 'contractStatus',
  ResetCycle: 'resetCycle',
});
